import {checkIfSuccubesUnitCouldSeduce} from "../../factions/checkIfSuccubesUnitCouldSeduce";
import {checkIfGoblinsUnitCouldUseAbility} from "../../factions/checkIfGoblinsUnitCouldUseAbility";
import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectFortressesUnderConstruction,
  selectGoblinsTraps,
  selectHexes,
  selectSpecialBuildings,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";

// Монеты на попытку берутся у переданного игрока, а не из состояния

export const checkIfUnitCanSeduce = (state, unit, player) => checkIfSuccubesUnitCouldSeduce(
  unit, selectUnits(state), player.coins,
  selectHexes(state), selectSpecialBuildings(state), selectBuildingsDamage(state),
  selectFortressesUnderConstruction(state)
);

export const checkIfUnitCanUseGoblinsAbility = (state, unit, player) => checkIfGoblinsUnitCouldUseAbility(
  unit, selectUnits(state), player.coins, selectHexes(state), selectCitiesCache(state),
  selectSpecialBuildings(state), selectBuildingsDamage(state), selectGoblinsTraps(state), player,
  selectFortressesUnderConstruction(state)
);

/**
 * Может ли отряд игрока применить способность этапа ABILITIES прямо сейчас:
 * соблазнение Суккубов или способность Гоблинов. Общая проверка для перехода
 * MOVEMENT → ABILITIES (handleCompleteTurn) и подсчета дел этапа способностей.
 * ВАЖНО: при добавлении новой фракции со способностями этапа ABILITIES её
 * проверку нужно добавить сюда же, иначе этап никогда не откроется для неё.
 */
export const checkIfUnitCanUseAbility = (state, unit, player) =>
  checkIfUnitCanSeduce(state, unit, player) || checkIfUnitCanUseGoblinsAbility(state, unit, player);
